import type { CopyShape } from "@tami/core/intl";

import type { PLAN_PRESENTATION_COPY_PT_BR } from "../plan-presentation.copy";

export const PLAN_PRESENTATION_COPY_ES_ES: CopyShape<typeof PLAN_PRESENTATION_COPY_PT_BR> = {
  fallbackPitchFree: "Acceso gratis a las funciones básicas. Sin sorpresas — y sin tarjeta.",
  fallbackPitchPaid: "Todo el producto, sin los límites del plan gratuito.",
  badge: {
    onRequest: "A medida",
    free: "100% Free",
    highlighted: "Mucha más Tãmi",
    default: "Sin límites",
  },
  ctaFree: "¡Empieza gratis ya!",
  ctaSubscribe: (shortPlanName: string): string => `Suscribirme a ${shortPlanName}`,
};
